import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import CellValue from 'components/CellValue'
import {fieldtype} from 'utils/enums/fieldtype'

const Container = styled.div`
    box-sizing: border-box;
    align-items: center;
    padding: 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
    justify-content: space-between;
`

const ValueType = styled.div`
    text-transform: uppercase;
    padding: 4px 10px;
    font-size: 10px;
    background-color: ${props => props.active ? '#415dd4' : 'rgba(160, 183, 190, .24)'};
    color: ${props => props.active ? '#fff' : '#7c9198'};
    cursor: pointer;
    margin-top: 5px;
    display: inline-block;
    border-radius: 2px;
    letter-spacing: 1px;

    :not(:last-child) {
        margin-right: 5px;
    }
`

const Block = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    width: 100%;
`

const Types = styled.div`
    align-items: flex-end;
    display: flex;
    margin-top: 5px;
`

const Input = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 45px;
    line-height: 45px;
`

const Cell = styled.div`
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: rgba(160, 183, 190, 0.24);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 230px;
`

class Field extends React.Component {
    handleChangeType = (value) => {
        this.props.handleChangeType(value, this.props.data.field.id)
    }

    handleChangeValue = (value, fieldId) => {
        this.props.handleChangeValue(value, fieldId)
    }

    handleSelect = (e) => {
        this.props.handleChangeValue(e.target.value, this.props.data.field.id)
    }

    getDefaultValue = () => {
        if (this.props.data.field.uiType === fieldtype.linkedfield) {
            const defaultItem = this.props.linkedOptions && this.props.mapping.customValue ?
                this.props.linkedOptions.find(item => item.id === this.props.mapping.customValue[0]) : undefined
            return defaultItem ? defaultItem.name : undefined
        } else {
            return this.props.mapping.customValue
        }
    }

    render() {
        const { intl, data, values, mapping } = this.props
        const defaultValue = mapping && mapping.type === values.custom && mapping.customValue ? this.getDefaultValue() : undefined

        return (
            <Container>
                {mapping && mapping.type === values.field &&
                    <Select
                        style={{minWidth: '230px'}}
                        value={mapping.sourceFieldId}
                        onChange={this.handleSelect}
						variant="standard"
                    >
                        {data.options.map(option =>
                            <MenuItem key={option.id} value={option.id}>
                                {option.singular}
                            </MenuItem>
                        )}
                    </Select>
                }
                {mapping && mapping.type === values.custom &&
                        <Cell>
                            <Input>
                                <CellValue
                                    config={data.field.uiConfig}
                                    type={data.field.uiType}
                                    defaultValue={defaultValue}
                                    linkedRelation={mapping.customValue}
                                    name={data.field.id}
                                    handleUpdateValue={this.handleChangeValue}
                                    disableCreate={true}
                                />
                            </Input>
                        </Cell>
                    }
                <Block>
                    <div>{data.field.singular}</div>
                    <Types>
                        {Object.keys(values).map((item, index) => {
                            if ((values[item] === values.link && !data.linkToSource) || values[item] === values.field) return null

                            return <ValueType key={index}
                                active={mapping ? mapping.type === values[item] : values[item] === values.empty}
                                name={item}
                                onClick={() => this.handleChangeType(values[item])}
                            >
                                {intl.formatMessage({id: `sidebar.data_export_value_${item}`})}
                            </ValueType>
                        })}
                    </Types>
                </Block>
            </Container>
        )
    }
}

export default injectIntl(Field)
